import React from 'react';
import Config from '../utils/config';
import LiveChatWidget from './liveChatWidget';

export default class liveChatWidgetWrap extends React.Component {
	
	render() {
		const chatConfig = Config.appConfig.LiveChartList;
		if (!chatConfig) {
			return false;
		}

		const container = JSON.parse(chatConfig.replace(/\#/g, ''));
		const chatList = [];
		for (const chat in container) {
			const obj = container[chat];
			const widget = (
				<LiveChatWidget key={obj.id} type={chat} liveChat={obj} popupDiv={this.props.popupDiv} />
			);

			chatList.push(widget);
		}
		return <div>{chatList}</div>;
	}
};
